import {createProductAgePolicyPending,modifyProductAgePolicyFail,modifyProductAgePolicySuccess,modifyProductAgePolicyPending,getSProductAgePolicyFail,getSProductAgePolicyPending,getSProductAgePolicySuccess, createProductAgePolicySuccess,createProductAgePolicyFail,getSAgePolicyPending} from "./agepolicySlice";
import { productagepolicyCreation,fetchSingleAgePolicy,productagepolicyModify } from "../../../api/userApi";



export const newProductAgePolicyCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createProductAgePolicyPending());
        const result = await productagepolicyCreation(frmDt);
        result.status === "success"
            ? dispatch(createProductAgePolicySuccess(result.message))
            : dispatch(createProductAgePolicyFail(result.message));

    } catch (error) {
   
        const err = JSON.parse(JSON.stringify(error.response.data.errors));

       
       const row = err.map((er, i) => {
 

       
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+' ';
          });
       
          dispatch(createProductAgePolicyFail(row));
     
       
       
       
    }

}

export const getSingleAgePolicy = (id) => async (dispatch) => {
    
 
    try {
     //call the api
    dispatch(getSProductAgePolicyPending());
    const result = await fetchSingleAgePolicy(id);

 console.log("royalab",result);

 
 //console.log('check user profile out if');
    if(result.productagepolicy[0] && result.productagepolicy[0].id){
    //console.log('check user profile');
        return dispatch(getSProductAgePolicySuccess(result.productagepolicy[0]));
    }
    dispatch(getSProductAgePolicyFail("product age policy is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
    dispatch(getSProductAgePolicyFail(err.msg));
 
 }
    
 
 }


export const agepolicyModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyProductAgePolicyPending());
        const result = await productagepolicyModify(frmDt);
        result.status === "success"
            ? dispatch(modifyProductAgePolicySuccess(result.message))
            : dispatch(modifyProductAgePolicyFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyProductAgePolicyFail(err.msg));
    }

}


